const SUB_PAGES = {
  MEAL_FORM: 'MEAL_FORM',
  MEAL_NOTES: 'MEAL_NOTES',
  DISH_SUBPAGE: 'DISH_SUBPAGE',
  FLOW_STATISTICS: 'FLOW_STATISTICS',
  ADVANCED_MEAL_FORM: 'ADVANCED_MEAL_FORM',
};

export default SUB_PAGES;
